import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d6b7e14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "duty-card" }
const _hoisted_3 = { class: "duty-card-partone" }
const _hoisted_4 = { class: "duty-person" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "person" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "position" }
const _hoisted_9 = { class: "time" }
const _hoisted_10 = { class: "duty-card-parttwo" }
const _hoisted_11 = { style: {"color":"#1e2124"} }
const _hoisted_12 = { class: "stress" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("天 ")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "当前工地出勤", -1))
const _hoisted_15 = { class: "right-part" }
const _hoisted_16 = { style: {"text-align":"right"} }
const _hoisted_17 = { class: "stress" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#1e2124"} }, "天", -1))
const _hoisted_19 = { class: "stressone" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "天", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "本月出勤天数/本月工作日", -1))
const _hoisted_22 = { class: "duty-list" }
const _hoisted_23 = { class: "item-top" }
const _hoisted_24 = { class: "item-time" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#8893a3"} }, "总工时:", -1))
const _hoisted_26 = { style: {"color":"#1e2124"} }
const _hoisted_27 = { class: "item-cont" }
const _hoisted_28 = { class: "project-name" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot" }, null, -1))
const _hoisted_30 = { class: "assess-cont" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "tip" }, "进"),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#8893a3"} }, "进入时间")
], -1))
const _hoisted_32 = { style: {"color":"#4a576a"} }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "tip out" }, "出"),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#8893a3"} }, "离开时间")
], -1))
const _hoisted_34 = { style: {"color":"#4a576a"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_nav_bar, {
        "left-arrow": "",
        title: _ctx.$route.meta.title,
        placeholder: "",
        onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              class: "avtor",
              src: _ctx.userInfo.photoUrl,
              alt: ""
            }, null, 8, _hoisted_5),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.userInfo.name), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.userInfo.stationName === null ? "无职位" : _ctx.userInfo.stationName), 1)
            ])
          ]),
          _createElementVNode("div", {
            class: "time-select",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.popupShow = true))
          }, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.showDate), 1),
            _createVNode(_component_van_icon, { name: "arrow-down" })
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.checkinDays), 1),
              _hoisted_13
            ]),
            _hoisted_14
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.checkinMonth), 1),
              _hoisted_18,
              _createElementVNode("span", _hoisted_19, " / " + _toDisplayString(_ctx.monthDay), 1),
              _hoisted_20
            ]),
            _hoisted_21
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_component_van_pull_refresh, {
          modelValue: _ctx.refreshing,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.refreshing) = $event)),
          onRefresh: _ctx.onRefresh
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_list, {
              loading: _ctx.loading,
              "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loading) = $event)),
              finished: _ctx.finished,
              "finished-text": "没有更多了",
              onLoad: _ctx.onLoad
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "list-item",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.getDate(item.createDate)), 1),
                      _createElementVNode("div", null, [
                        _hoisted_25,
                        _createElementVNode("span", _hoisted_26, _toDisplayString(item.hour.toFixed(1)) + "h", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createElementVNode("div", null, _toDisplayString(item.projectName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", null, [
                          _hoisted_31,
                          _createElementVNode("div", _hoisted_32, _toDisplayString(item.inDate == null ? "未签到" : _ctx.getTime(item.inDate)), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_33,
                          _createElementVNode("div", _hoisted_34, _toDisplayString(item.outDate == null ? "未签到" : _ctx.getTime(item.outDate)), 1)
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["loading", "finished", "onLoad"])
          ]),
          _: 1
        }, 8, ["modelValue", "onRefresh"])
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.popupShow,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.popupShow) = $event)),
      round: "",
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_datetime_picker, {
          modelValue: _ctx.pickerValue,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pickerValue) = $event)),
          type: "year-month",
          title: "选择年月",
          onConfirm: _ctx.fSelectTime
        }, null, 8, ["modelValue", "onConfirm"])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}